// extracted by mini-css-extract-plugin
module.exports = {"basket":"basket-icon_basket__iO8n6","number-items":"basket-icon_number-items__MXenD","basket-icon":"basket-icon_basket-icon__eza74"};